import { render, staticRenderFns } from "./prioritizeModal.vue?vue&type=template&id=26bc2b4f&scoped=true&"
import script from "./prioritizeModal.vue?vue&type=script&lang=js&"
export * from "./prioritizeModal.vue?vue&type=script&lang=js&"
import style0 from "./prioritizeModal.vue?vue&type=style&index=0&id=26bc2b4f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bc2b4f",
  null
  
)

export default component.exports